import { render } from "./ui-button.vue?vue&type=template&id=e5c48228"
import script from "./ui-button.vue?vue&type=script&lang=js"
export * from "./ui-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__